import useProductsByCategorySlug from './useProductsByCategorySlug'

export default useProductsByCategorySlug
